/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { gql, useQuery } from '@apollo/client';
import CONFIG from '../../config';


interface Privacy {
  privacyPolicy: any;
}

interface QueryResult {
  termsOfUseAndPrivacyPolicy: Privacy;
}

export const PrivacyPolicy = () => {
  const { data, error } = useQuery<QueryResult>(FeedQuery, {
    variables: {
      id: CONFIG.graphCMSLegalId
    },
  });

  if (error || !data?.termsOfUseAndPrivacyPolicy) {
    return <></>
  }
  return (
    <div className='legal'>
      <div
        className='solution-text'
        dangerouslySetInnerHTML={{ __html: data.termsOfUseAndPrivacyPolicy.privacyPolicy.html }}
      />
    </div>
  )
}

const FeedQuery = gql`
  query($id: ID!){
    termsOfUseAndPrivacyPolicy (where: { id: $id }, stage: PUBLISHED) {
      privacyPolicy {
        html
        }
    }
  }
`;
